export enum AttachmentDownloadOption {
    Never = 'never',
    Wifi = 'wifi',
    WifiAndCellular = 'wifiAndCellular'
}